<div class="success--container">
  <img src="/assets/img/icon_success.png" />
  <ng-container *ngIf="data?.isDefault; else caltexOrReceiptSuccess">
    <div class="success--title">{{ data.title }}</div>
    <div class="success--desc">{{ data.description }}</div>
    <div class="okay--btn" [mat-dialog-close]>
      {{ "common.close" | translate }}
    </div>
  </ng-container>
  <ng-template #caltexOrReceiptSuccess>
    <ng-container *ngIf="data?.isCaltex; else receiptSuccess">
      <div class="success--title">
        {{ "common.receipt.invoiceSuccessTitle" | translate }}
      </div>
      <div
        class="success--desc"
        [innerHTML]="'common.receipt.invoiceSuccessDesc' | translate"
      ></div>
      <div class="okay--btn" (click)="goToReceiptList()" [mat-dialog-close]>
        {{ "common.amplify.okay" | translate }}
      </div>
    </ng-container>
  </ng-template>
  <ng-template #receiptSuccess>
    <div class="success--title">{{ "common.success._!" | translate }}</div>
    <div class="success--desc" *ngIf="!data.edit">
      {{ "common.receipt.receiptSuccess" | translate }}
    </div>
    <div class="success--desc" *ngIf="data.edit">
      {{ "common.receipt.editReceiptSuccess" | translate }}
    </div>
    <div class="okay--btn" (click)="goToReceiptList()" [mat-dialog-close]>
      {{ "common.close" | translate }}
    </div>
  </ng-template>
</div>
